import Backbone from 'backbone';
import _ from 'underscore';

import { OptedOutModel } from './OptedOutModel';

export const OptedOutCollection = Backbone.Collection.extend({

	model: OptedOutModel,
	
	initialize: function() {
		this.channel = Backbone.Radio.channel( 'AppChannel' );
		this.app = this.channel.request( 'app' );
	},

});